import styled from "@emotion/styled";
import { fontSizes } from "./typography";
import {
  mediaAbove,
  mediaBelow,
  lineHeight,
  interactive,
  text,
} from "@atlas-int/tokens";

const TextBoxContainer = styled.div<{ active: boolean; toggle: boolean }>`
  width: 100%;
  margin: 0.5rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: ${fontSizes.bodyText};
  color: ${text.primary};
  line-height: ${lineHeight.loose};
  box-sizing: border-box;
  padding: ${({ toggle }) => (toggle ? "0 1rem" : "1rem")};

  ${mediaAbove("md")} {
    border-left: ${({ active }) =>
      active ? `7px solid ${interactive.muted}` : "7px solid transparent"};
  }

  ${mediaBelow("md")} {
    padding: 0 1rem;
    font-size: ${fontSizes.centeredBodyText};
    text-align: center;
`;

export default function TextBox({
  isActive,
  children,
  isToggle = false,
}: {
  isActive: boolean;
  children: React.ReactNode;
  isToggle?: boolean;
}) {
  return (
    <TextBoxContainer active={isActive} toggle={isToggle}>
      {children}
    </TextBoxContainer>
  );
}
